export const GET_EVENTS_LIST = "GET_EVENTS_LIST";
export const GET_EVENTS_LIST_SUCCESS = "GET_EVENTS_LIST_SUCCESS";
export const GET_EVENTS_LIST_ERROR = "GET_EVENTS_LIST_ERROR";

export const GET_ALL_EVENTS_LIST = "GET_ALL_EVENTS_LIST";
export const GET_ALL_EVENTS_LIST_SUCCESS = "GET_ALL_EVENTS_LIST_SUCCESS";
export const GET_ALL_EVENTS_LIST_ERROR = "GET_ALL_EVENTS_LIST_ERROR";

export const GET_MY_EVENTS = "GET_MY_EVENTS";
export const GET_MY_EVENTS_SUCCESS = "GET_MY_EVENTS_SUCCESS";
export const GET_MY_EVENTS_ERROR = "GET_MY_EVENTS_ERROR";

export const GET_EVENT_INFO = "GET_EVENT_INFO";
export const GET_EVENT_INFO_SUCCESS = "GET_EVENT_INFO_SUCCESS";
export const GET_EVENT_INFO_ERROR = "GET_EVENT_INFO_ERROR";

export const GET_EDITABLE_EVENT_ACTION = "GET_EDITABLE_EVENT_ACTION";
export const GET_EDITABLE_EVENT_ACTION_SUCCESS =
  "GET_EDITABLE_EVENT_ACTION_SUCCESS";
export const GET_EDITABLE_EVENT_ACTION_ERROR =
  "GET_EDITABLE_EVENT_ACTION_ERROR";

export const SET_EDITABLE_EVENT_ACTION = "SET_EDITABLE_EVENT_ACTION";
export const SET_EDITABLE_EVENT_ACTION_SUCCESS =
  "SET_EDITABLE_EVENT_ACTION_SUCCESS";
export const SET_EDITABLE_EVENT_ACTION_ERROR =
  "SET_EDITABLE_EVENT_ACTION_ERROR";

export const CREATE_EVENT_ACTION = "CREATE_EVENT_ACTION";
export const CREATE_EVENT_ACTION_SUCCESS = "CREATE_EVENT_ACTION_SUCCESS";
export const CREATE_EVENT_ACTION_ERROR = "CREATE_EVENT_ACTION_ERROR";

export const CHECK_USER_IS_OWNER_SUCCESS = "CHECK_USER_IS_OWNER_SUCCESS";
export const CHECK_USER_IS_OWNER_ERROR = "CHECK_USER_IS_OWNER_ERROR";

export const DELETE_MISSION_ACTION = "DELETE_MISSION_ACTION";
export const DELETE_MISSION_ACTION_SUCCESS = "DELETE_MISSION_ACTION";
export const DELETE_MISSION_ACTION_ERROR = "DELETE_MISSION_ACTION";

export const GET_EVENT_INFO_END_LIVE_UPDATES =
  "GET_EVENT_INFO_END_LIVE_UPDATES";

export const getEventsListAction = () => ({
  type: GET_EVENTS_LIST,
});

export const getEventsListActionSuccess = (payload) => ({
  type: GET_EVENTS_LIST_SUCCESS,
  payload,
});

export const getEventsListActionError = (payload) => ({
  type: GET_EVENTS_LIST_ERROR,
  payload,
});

export const getAllEvents = () => ({
  type: GET_ALL_EVENTS_LIST,
});

export const getAllEventsSuccess = () => ({
  type: GET_ALL_EVENTS_LIST_SUCCESS,
});

export const getAllEventsError = () => ({
  type: GET_ALL_EVENTS_LIST_ERROR,
});

export const getMyEventsAction = (payload) => ({
  type: GET_MY_EVENTS,
  payload,
});

export const getMyEventsSuccess = (payload) => ({
  type: GET_MY_EVENTS_SUCCESS,
  payload,
});

export const getMyEventsError = (payload) => ({
  type: GET_MY_EVENTS_ERROR,
  payload,
});

export const getEventInfoAction = (payload) => ({
  type: GET_EVENT_INFO,
  payload,
});

export const getEventInfoActionSuccess = (payload) => ({
  type: GET_EVENT_INFO_SUCCESS,
  payload,
});

export const getEventInfoActionError = () => ({
  type: GET_EVENT_INFO_ERROR,
});

export const getEditableEventAction = (payload) => ({
  type: GET_EDITABLE_EVENT_ACTION,
  payload,
});

export const getEditableEventActionSuccess = (payload) => ({
  type: GET_EDITABLE_EVENT_ACTION_SUCCESS,
  payload,
});

export const getEditableEventActionError = () => ({
  type: GET_EDITABLE_EVENT_ACTION_ERROR,
});

export const setEditableEventAction = (payload) => ({
  type: SET_EDITABLE_EVENT_ACTION,
  payload,
});

export const setEditableEventActionSuccess = (payload) => ({
  type: SET_EDITABLE_EVENT_ACTION_SUCCESS,
  payload,
});

export const setEditableEventActionError = (payload) => ({
  type: SET_EDITABLE_EVENT_ACTION_ERROR,
  payload,
});

export const createEventAction = (payload) => ({
  type: CREATE_EVENT_ACTION,
  payload,
});

export const createEventActionSuccess = (payload) => ({
  type: CREATE_EVENT_ACTION_SUCCESS,
  payload,
});

export const createEventActionError = (payload) => ({
  type: CREATE_EVENT_ACTION_ERROR,
  payload,
});

export const checkIsUserOwnerOfMissionSuccess = (payload) => ({
  type: CHECK_USER_IS_OWNER_SUCCESS,
  payload,
});

export const checkIsUserOwnerOfMissionError = (payload) => ({
  type: CHECK_USER_IS_OWNER_ERROR,
  payload,
});

export const deleteMissionAction = (payload) => ({
  type: DELETE_MISSION_ACTION,
  payload,
});

export const deleteMissionSuccessAction = (payload) => ({
  type: DELETE_MISSION_ACTION_SUCCESS,
  payload,
});

export const deleteMissionErrorAction = (payload) => ({
  type: DELETE_MISSION_ACTION_ERROR,
  payload,
});

export const getEventInfoEndUpdatesAction = (payload) => ({
  type: GET_EVENT_INFO_END_LIVE_UPDATES,
  payload,
});
